import React from 'react';
import { Outlet } from 'react-router-dom';
import { get, edit } from '../../../features/mission/actions';

const index = () => {
  const page = 'Mission';
  return (
    <div style={{ height: '100%', paddingTop: '4rem' }}>
      <Outlet context={[{ page, get, edit }]} />
    </div>
  );
};

export default index;
